import { JSX } from "react";
import UICustomizationViewCategoryListSettings from "../../../../components/ui-customization-settings/UICustomizationViewCategoryListSettings";

export default function PageVisibilityStep(): JSX.Element {
    return (
        <UICustomizationViewCategoryListSettings isLoading={false} />
    );
}